// services/chatApi.js
import { API_BASE_URL, getAuthHeaders } from './api';

const jsonOrThrow = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(`HTTP error! status: ${res.status}${text ? ` – ${text}` : ''}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
};

export const fetchChatMessages = async (chatWithUserId, region) => {
  let url = `${API_BASE_URL}/chat/messages`;
  
  // If chatWithUserId is provided, use it as a path parameter (for MessagesPage)
  // If not provided, use query parameter (for ChatWidget)
  if (chatWithUserId) {
    url += `/${chatWithUserId}?region=${encodeURIComponent(region)}`;
  } else {
    url += `?region=${encodeURIComponent(region)}`;
  }
  
  console.log('[chatApi] fetchChatMessages called with:', { 
    chatWithUserId, 
    region, 
    finalUrl: url 
  });
  
  const headers = await getAuthHeaders();
  const res = await fetch(url, { headers });
  
  const result = await jsonOrThrow(res);
  console.log('[chatApi] fetchChatMessages response:', { 
    messageCount: result?.messages?.length || 0,
    unreadCount: result?.unreadCount || 0,
    firstMessage: result?.messages?.[0]
  });
  
  return result;
};




export const sendChatMessage = async ({ message, recipientId, region }) => {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_BASE_URL}/chat/send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({ message, recipientId, region }),
  });
  return jsonOrThrow(res);
};

export const markMessagesAsRead = async (chatWithUserId, region) => {
  const headers = await getAuthHeaders();
  
  // Build the URL with proper query parameters
  let url = `${API_BASE_URL}/chat/read`;
  if (chatWithUserId) {
    url += `/${chatWithUserId}?region=${encodeURIComponent(region)}`;
  } else {
    url += `?region=${encodeURIComponent(region)}`;
  }
  
  console.log('[chatApi] markMessagesAsRead called with:', { chatWithUserId, region, url });
  
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({ userId: chatWithUserId, region }), // Keep body for backward compatibility
  });
  
  return jsonOrThrow(res);
};


export const fetchChatUsers = async (region) => {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_BASE_URL}/chat/users?region=${encodeURIComponent(region)}`, { headers });
  return jsonOrThrow(res);
};
